/**
 * Quốc gia đang thao tác. Dữ liệu (user / brand / link) được chia tách theo
 * quốc gia ở phía API; client chỉ việc gửi kèm header `X-Country` ở mọi request.
 *
 * Chỉ **superadmin** đổi được — API bỏ qua header với các vai trò khác nên user
 * thường có sửa localStorage cũng không xem được dữ liệu quốc gia khác.
 *
 * Danh sách phải khớp `COUNTRIES` bên API (`src/common/country.ts`).
 */
export const COUNTRIES = ["vn", "br"] as const;

export type Country = (typeof COUNTRIES)[number];

export const DEFAULT_COUNTRY: Country = "vn";

/** Nhãn hiển thị + cờ, dùng chung cho nút chuyển và các cột trong bảng. */
export const COUNTRY_META: Record<Country, { flag: string; label: string }> = {
  vn: { flag: "🇻🇳", label: "Việt Nam" },
  br: { flag: "🇧🇷", label: "Brazil" },
};

const COUNTRY_KEY = "acc.country";

export function isCountry(value: unknown): value is Country {
  return typeof value === "string" && (COUNTRIES as readonly string[]).includes(value);
}

/** Quốc gia đang chọn (lưu localStorage để giữ nguyên sau khi tải lại trang). */
export function getCountry(): Country {
  const saved = localStorage.getItem(COUNTRY_KEY);
  return isCountry(saved) ? saved : DEFAULT_COUNTRY;
}

export function setCountry(country: Country) {
  localStorage.setItem(COUNTRY_KEY, country);
}

/**
 * Đổi quốc gia rồi tải lại trang.
 *
 * Cố tình dùng reload thay vì set state: mọi màn hình đều nạp dữ liệu qua
 * `useAsync` với dependency riêng, nên nếu chỉ đổi biến thì sẽ còn màn hình giữ
 * dữ liệu của quốc gia cũ — nguy hiểm hơn hẳn một lần tải lại.
 */
export function switchCountry(country: Country) {
  if (country === getCountry()) return;
  setCountry(country);
  window.location.reload();
}
